import { Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { SearchContainer } from "../SearchComponent";

type TabSearchContainerProps = {
  children: React.ReactNode;
} & TabControllerProps;
export const TabSearchContainer = ({ children, ...others }: TabSearchContainerProps) => {
  return (
    <SearchContainer>
      <TabController {...others} />
      {children}
    </SearchContainer>
  );
};
type TabControlItemType = {
  label: string;
  value: any;
};
type TabControllerProps = {
  tabs: TabControlItemType[];
  onChange?: (value: any) => void;
  value?: any;
  indicatorColor?: string;
  fontSize?: string;
};
export const TabController = ({ tabs, onChange, value, fontSize = "1.5rem", indicatorColor }: TabControllerProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const handleChange = (e, value) => {
    if (typeof onChange !== "undefined") {
      onChange(value);
    } else {
      navigate(value);
    }
  };
  return (
    <Tabs
      TabIndicatorProps={{ hidden: !indicatorColor }}
      value={value ?? pathname}
      onChange={handleChange}
      sx={{
        "& .MuiTab-root": {
          fontSize: fontSize,
          fontWeight: 700,
          color: "text.disabled",
          "&.Mui-selected": {
            color: "text.primary",
          },
          "&:first-of-type": {
            paddingLeft: 0,
          },
        },
        "& .MuiTabs-indicator": {
          backgroundColor: indicatorColor,
        },
      }}
    >
      {tabs.map((tab, index) => (
        <Tab key={index} sx={{}} label={tab.label} value={tab.value} />
      ))}
    </Tabs>
  );
};
